import { render } from "./BranchDepartmentsSearch.vue?vue&type=template&id=ba2dd0fe"
import script from "./BranchDepartmentsSearch.vue?vue&type=script&lang=js"
export * from "./BranchDepartmentsSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__